export default "__VITE_ASSET__DcMg42Xu__"